import type { SupervisorCheckPrecision } from '@avisoma/shared';
import { Badge } from '../../catalyst/badge';
import { precisionLabel, precisionTitle } from './correctionsGrouping';

/**
 * Check-group header chip: weak precision from finding actions, plus "autofix" when the check is on the allowlist.
 * The tooltip starts with the server's `weakLabelNote`, which names the weak-label rules.
 */
export function PrecisionChip({
  precision,
  weakLabelNote,
}: {
  precision: SupervisorCheckPrecision | undefined;
  weakLabelNote: string;
}) {
  if (!precision) return null;
  return (
    <span className="inline-flex items-center gap-1.5">
      <Badge color="zinc" title={[weakLabelNote, precisionTitle(precision)].filter(Boolean).join('\n')}>
        {precisionLabel(precision)}
      </Badge>
      {precision.autofix && <Badge color="indigo">autofix</Badge>}
    </span>
  );
}
